import { IconComponent } from 'design-system/types'

export const AIIcon: IconComponent = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 12 12"
    {...props}>
    <path
      fill="currentColor"
      stroke="currentColor"
      d="m9.64 8.952.084.2.199.082.486.204-.486.203-.2.083-.082.199-.204.486-.203-.486-.083-.2-.199-.082-.487-.204.487-.203.2-.083.082-.199.204-.487.203.487ZM5.673 4.707l.078.157.157.078 2.096 1.05-2.096 1.05-.157.08-.078.155-1.047 2.097-1.046-2.097-.078-.156-.156-.079-2.098-1.05 2.098-1.05.156-.078.078-.157L4.625 2.61l1.047 2.097Zm3.969-2.63.083.2.199.082.486.204-.486.203-.2.083-.082.199-.204.486-.203-.486-.083-.2-.199-.082-.487-.204.487-.203.2-.083.082-.199.204-.487.203.487Z"
    />
  </svg>
)
